import App from './App.velvet';
import './style.css';


const app = new App();
document.body.appendChild(app);
